module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  if (locals.loggedIn) { 
    ; __append(" <div class=\"dropdown\"> <a href=\"#\" class=\"dropdown-toggle nav-link p-0\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\"> ")
    ; __append(escapeFn( locals.email ))
    ; __append(" </a> <ul class=\"dropdown-menu\"> ")
    ;  locals.collection.forEach(function(item) { 
    ; __append(" <a href=\"/account/")
    ; __append(escapeFn( item.get('route') ))
    ; __append("\" class=\"dropdown-item\">")
    ; __append(escapeFn( item.get('readable') ))
    ; __append("</a> ")
    ;  }); 
    ; __append(" <li href=\"#\" id=\"signout\" class=\"dropdown-item\">Sign Out</li> </ul> </div> ")
    ;  } 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/user_nav.ejs
// module id = 1192
// module chunks = 1